const navigationSi = {
    "menu_editor": "Meni",
    "settings": "Nastavitve",
    "payment_settings": "Nastavitve plačil",
    "user_management": "Upravljanje uporabnikov",
    "logout": "Odjava",
    "subscription": "Naročnina",
    "new_restaurant": "Ustvari novo restavracijo",
    "privacy_policy": "Pravilnik o zasebnosti",
    "terms_and_conditions": "Pogoji poslovanja",
    "statistics": "Statistika",
    "mozrest": "Vodja pregledov",
    "signup": "Prijavi se"
};

export default navigationSi;
